module.exports = __webpack_public_path__ + "static/media/search-icon.f7b25415.svg";